import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DetalleCaja, DetalleIngreso } from 'src/app/model/index.model';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class DetalleIngresoService extends BaseService<DetalleIngreso> {

    constructor(protected override http: HttpClient) {
        super(http, 'detalleIngreso');
    }


}
